type LinkGoogleMapsProps = {
    streetName: string | undefined;
    streetNumber: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
};

const LinkGoogleMaps = ({ streetName, streetNumber, postalCode, city }: LinkGoogleMapsProps) => {
    return (
        <a
            href={`https://www.google.com/maps/search/?api=1&query=${streetName}+${streetNumber}+${postalCode}+${city}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {streetName} {streetNumber}, {postalCode} {city}
        </a>
    );
};

export default LinkGoogleMaps;
